<div class="cipc-score">
  <div class="form-group mb-3">
    <label for="company_name" class="fw-bold text-xs">Company Name</label>
    <input
      type="text"
      v-model="form.company_name"
      id="company_name"
      class="form-control text-xs rounded-small p-3 shadow-sm"
      placeholder="e.g., ABC Trading"
      required
    />
  </div>
  <div class="form-group">
    <label for="registration_number" class="fw-bold text-xs"
      >Registration Number</label
    >
    <input
      type="text"
      v-model="form.registration_number"
      id="registration_number"
      class="form-control text-xs rounded-small p-3 shadow-sm"
      placeholder="e.g., 2019/035203/21"
      @input="format_registration_number"
      required
    />
  </div>
  <small class="form-text text-danger d-none error-message text-xs fw-bold">
    Please fill in this field
  </small>
  <div class="d-flex justify-content-end my-2">
    <button
      @click="handle_submit"
      class="btn btn-primary-color rounded-pill text-xs"
    >
      Run Service
    </button>
  </div>
</div>
